import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/requests',
    component: () => import('@/views/Requests/Index.vue'),
    meta: {
      requiresAuth: true,
    }
  },
]

export default routes;